export function buildWhatsAppHref(
  phoneNumber: string,
  options?: { defaultCountryCode?: string; text?: string },
): string | null {
  const defaultCountryCode = options?.defaultCountryCode ?? "55";

  let digits = phoneNumber.replace(/\D/g, "");
  if (!digits) return null;

  if (digits.startsWith("00")) digits = digits.slice(2);
  if (digits.startsWith("0")) digits = digits.slice(1);

  // Common case in this app: BR numbers stored as DDD+number (10/11 digits, no country code).
  if (
    (digits.length === 10 || digits.length === 11) &&
    !digits.startsWith(defaultCountryCode)
  ) {
    digits = `${defaultCountryCode}${digits}`;
  }

  // E.164 max length is 15 digits; WhatsApp (wa.me) expects digits only.
  if (digits.length < 8 || digits.length > 15) return null;

  const baseUrl = `https://wa.me/${digits}`;
  if (!options?.text?.trim()) return baseUrl;

  return `${baseUrl}?text=${encodeURIComponent(options.text)}`;
}
